


























































































































































import * as _ from 'lodash'
import BarChart from '@/elements/BarChart.vue'
import datefield from '@/form/Datefield.vue'
import moment from 'moment'
import q from 'q'
import StatisticsTableFull from '@/components/StatisticsTableFull.vue'
import TableDownloadButton from '@/elements/TableDownloadButton.vue'
import xhr from '@/services/XHR.coffee'
import { mapState } from 'vuex'

XHR = new xhr()

export default {
  name: 'Statistics'

  data: () ->
    data_is_loaded: false
    response: []
    age_ranges: []
    age_ranges_strings: []
    clients_by_status:
      active: []
      closed: []
      'new': []
    years_of_birth: []
    clients_by_status_and_age:
      active: []
      closed: []
      'new': []
      by_property: {}
    start: moment().startOf('year').format('YYYY-MM-DD')
    end: moment().endOf('year').format('YYYY-MM-DD')
    sort_order: 'asc'
    sort_key: 'name'

  components:
    'v-datefield': datefield
    'v-statisticstable-full': StatisticsTableFull
    'v-barchart': BarChart
    'download-button': TableDownloadButton

  methods:

    toggle: (val) ->
      console.log val

    groupByAge: (years_of_birth, clients) ->
      result = []
      for client in clients
        for range, idx in years_of_birth
          result[idx] = result[idx] || {}
          if client.year <= range[0] && client.year >= range[1]
            result[idx][client.gender] = (result[idx][client.gender] || []).concat client
      result

    groupByGender: (clients) ->
      result = {}

      ['male', 'female', 'hen'].map (gender)->
        result[client.gender] = (result.gender || []).concat client for client in clients

      result

    getConfig: (key) ->
      c = _.filter(@config, {key: key})
      c[0].value

    sumLengthByKey: (arr, key) ->
      sum = 0
      sum = sum + (item[key] || []).length for item in arr
      sum

    fetch: (status) ->
      try
        clients = await XHR.get(
          @resources.getLink('client.list').href,
            status: status + ',' + @start + ',' + @end
        )

        clients.getEmbeds('clients');

      catch e
        console.log e

    setupAgeRanges: () ->
      try
        this_year = moment().format('Y')

        await @$store.dispatch('getConfigs')
        @age_ranges = @getConfig('age_ranges')
        @years_of_birth = []
        @age_ranges_strings = []
        for age in @age_ranges
          @years_of_birth.push [this_year - age[0], this_year - age[1]]
          @age_ranges_strings.push age[0] + ' - ' + age[1]

      catch e
        console.log e

    setupProperties: (clients, cluster) ->
      for group in @groups.getEmbeds('client_property_groups')
        for property in group.getEmbeds('client_property_definitions')
          for client in clients
            for prop in client.getEmbeds 'client_property'
              if (property.type == 'BOOLEAN') and (prop.property_uid == property.uid) and (prop.value == true)
                c = cluster[group.uid]['properties'][prop.property_uid][client.gender] ? []
                @$set cluster[group.uid]['properties'][prop.property_uid], client.gender, c.concat client

    initDataStructures: () ->
      new Promise (resolve, reject) =>
        if not @are_loaded.resources then await @$store.dispatch 'getServices'
        if not @are_loaded.groups then await @$store.dispatch 'getGroups'
        if not @are_loaded.activities then await @$store.dispatch 'getActivities', { start: @start, end: @end }

        # Setup structure by property
        for group in @groups.getEmbeds('client_property_groups')
          @$set @clients_by_status_and_age.by_property, group.uid,
            label: group.name
            properties: {}
          for property in _.orderBy group.getEmbeds('client_property_definitions'), ['sortorder']
            @$set @clients_by_status_and_age.by_property[group.uid]['properties'], property.uid,
              label: property.label
              type: property.type
              man: []
              woman: []
              hen: []

        @setupAgeRanges()
          .then () =>
            ['active', 'closed', 'new'].map (status) =>

              if @clients_by_status_and_age[status] == undefined
                @$set @clients_by_status_and_age, status, []

              for range in @age_ranges
                  @clients_by_status_and_age[status].push
                    man: []
                    woman: []
                    hen: []

            resolve true

          .catch (e) ->
            reject e

    toggleSortOrder: ->
      if @sort_order == 'asc' then @sort_order ='desc' else @sort_order ='asc'
      console.log @sort_order

    sort: (key) ->
      if @sort_key == key
        @toggleSortOrder()
        return

      @sort_key = key
      @sort_order = 'asc'

    sortClass: (key) ->
      if key == @sort_key
        if @sort_order == 'asc'
          'mdl-data-table__header--sorted-ascending': true
        else
          'mdl-data-table__header--sorted-descending': true

    sortedActivities: () ->
      acts= []
      for activity in @activities.getEmbeds('activities')
        act = _.cloneDeep activity
        act.activity_type_label = activity.getEmbed('activity_type').name
        acts.push act

      _.orderBy acts, [(item) => item[@sort_key]?.toLowerCase()], [@sort_order]

    refreshData: () ->
      @$store.dispatch 'xhrIsLoading', true
      await @initDataStructures()
      await @$store.dispatch 'getActivities', { start: @start, end: @end }
      clients = await Promise.all(['active', 'closed', 'new'].map (status) =>
        @fetch status
      )

      @$set(@clients_by_status, status, clients[idx]) for status, idx in ['active', 'closed', 'new']

      # Reset matrix
      for status, clients of @clients_by_status_and_age
        for age_group, age_range_idx in clients
          for gender in ['man', 'woman', 'hen']
            @$set @clients_by_status_and_age[status][age_range_idx], gender, []



      # Populate matrix
      for status, clients of @clients_by_status
        grouped_by_age =  @groupByAge(@years_of_birth, clients)
        for age_group, age_range_idx in grouped_by_age
          for gender, klients of age_group
            for client in klients
              @clients_by_status_and_age[status][age_range_idx][gender].push client

      @setupProperties @clients_by_status.active, @clients_by_status_and_age.by_property

      @data_is_loaded = true
      await console.log 'Data is refreshed: ', @clients_by_status_and_age
      @$store.dispatch 'xhrIsLoading', false

    getTableRef: (key) ->
      typeIsArray = Array.isArray || ( value ) -> return {}.toString.call( value ) is '[object Array]'

      table = @$refs[key]
      if not typeIsArray table then table = [table]
      table[0]

  created: ->
    @$store.dispatch 'xhrIsLoading', true
    await @initDataStructures()
    @refreshData()
    @$store.dispatch 'xhrIsLoading', false

  # updated: ->
    # typeIsArray = Array.isArray || ( value ) -> return {}.toString.call( value ) is '[object Array]'

    # @$nextTick ->
    #   for k, table of @$refs
    #     if not typeIsArray table then table = [table]
    #     @tables[k] = table[0]

    #   console.log 'tables: ', @tables

  watch:
    'start': () ->
      @refreshData()
    'end': () ->
      @refreshData()

  computed:
    mapState
      isLoading: (state) ->
        state.xhr_is_loading
      resources: (state) ->
        state.resources
      config: (state) ->
        state.configs.getEmbeds 'config'
      groups: (state) ->
        state.cprop_groups
      are_loaded: (state) ->
        state.are_loaded
      activities: (state) ->
        state.activities
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Statistics.vue